import dayjs from 'dayjs';

import { objToSnake } from 'utils/general';

const formatNumber = (value) => {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const formatDate = (date) => {
  if (!date) return null;
  const d = dayjs(date);
  return d.isValid() ? d.format('YYYY-MM-DD') : null;
};

export const formatLocation = (location) => {
  if (!location) return null;

  return {
    place_id: location?.placeId || null,
    name: location?.name || null,
    map_url: location?.mapUrl || null,
    formatted_address: location?.formattedAddress || null,
    data: typeof location?.data === 'string' ? location.data : null,
    city: location?.city || null,
    subregion: location?.subregion || null,
    postcode: location?.postcode || null,
    region: location?.region || null,
    region_short_name: location?.regionShortName || null,
    street_address: location?.streetAddress || null,
    street_address_line_2: location?.streetAddressLine_2 || null,
    country: location?.country || null,
    latitude: formatNumber(location?.latitude),
    longitude: formatNumber(location?.longitude),
  };
};

export const formatContact = (contact) => {
  if (!contact) return null;

  const mapAddress = (a) => ({
    po_box: a?.poBox ?? null,
    street: a?.street ?? null,
    extended: a?.extended ?? null,
    city: a?.city ?? '',
    region: a?.region ?? null,
    subregion: a?.subregion ?? null,
    postcode: a?.postcode ?? null,
    country: a?.country ?? '',
    metro_area_id: formatNumber(a?.metroAreaId),
  });

  const mapTextField = (t) => ({
    ap_label_id: t?.apLabelId ?? null,
    field_label: t?.fieldLabel ?? '',
    field_value: t?.fieldValue ?? '',
  });

  return {
    addresses: Array.isArray(contact.addresses)
      ? contact.addresses.map(mapAddress)
      : [],
    phones: Array.isArray(contact.phones)
      ? contact.phones.map(mapTextField)
      : [],
    emails: Array.isArray(contact.emails)
      ? contact.emails.map(mapTextField)
      : [],
    websites: Array.isArray(contact.websites)
      ? contact.websites.map(mapTextField)
      : [],
    auto_responder_on_off: contact?.autoResponderOnOff ?? false,
    email_subject: contact?.emailSubject ?? '',
    email_body: contact?.emailBody ?? '',
    document_template_id: formatNumber(contact?.documentTemplateId),
  };
};

export const prepareLeadForApi = (leadData) => {
const { lead, contact, location } = leadData;
  const allDay = !!lead?.allDay;

  const payload = {
    contact_first_name: lead?.contactFirstName || '',
    contact_last_name: lead?.contactLastName || '',
    notes: lead?.notes || null,
    role: lead?.role || null,
    venue_name: lead?.venueName || null,
    status: lead?.status || null,
    lost_reason: lead?.lostReason || null,
    timezone: lead?.timezone || null,
    wedding_date: formatDate(lead?.weddingDate),
    date_inquiry: formatDate(lead?.dateInquiry),

    estimated_guest_count: formatNumber(lead?.estimatedGuestCount),
    estimated_budget: formatNumber(lead?.estimatedBudget),

    location: location ? formatLocation(location) : null,
    contact: contact ? formatContact(contact) : null,

    created_by_id: formatNumber(lead?.createdById),
    lead_source_id: formatNumber(lead?.leadSourceId),

    service_type_id: formatNumber(lead?.serviceTypeId),
    reason_for_not_booking_id: formatNumber(lead?.reasonForNotBookingId),
    last_contacted_date: formatDate(lead?.lastContactedDate),

    is_deleted: !!lead?.isDeleted,
    lead_custom_status_id: formatNumber(lead?.leadCustomStatusId),
    is_saved_lead: !!lead?.isSavedLead,

    all_day: allDay,
    start_time: allDay ? null : lead?.startTime || null,
    end_time: allDay ? null : lead?.endTime || null,

    project_name: lead?.projectName || null,
    project_type: lead?.projectType,
    contact_company_name: lead?.contactCompanyName || null,

    party: Array.isArray(lead?.party)
      ? lead.party.map((m) => [m?.[0] || '', m?.[1] || '', m?.[2] || ''])
      : [],
  };

  return payload;
};

export const prepareChecklistItemForApi = (checklistItem) => {
  const payload = {
    name: checklistItem?.name || '',
    details: checklistItem?.details || null,
    completed: checklistItem?.completed || false,
    due_date: formatDate(checklistItem?.dueDate),
    timeframe: checklistItem?.timeframe ? objToSnake(checklistItem?.timeframe) : null,
    assignment_note: checklistItem?.assignmentNote || null,
  };
  return payload;
};
